require('./slider.html');
require('./carousel.html');
require('./slider.controller');